import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const TagSelectorModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const TagSelectorContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
`;

export const TagSelectorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  h3 {
    margin: 0;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: ${COLORS.SECONDARY};
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: ${COLORS.PRIMARY};
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid ${props => props.variant === 'primary' ? COLORS.PRIMARY : '#ddd'};
  border-radius: 4px;
  background: ${props => props.variant === 'primary' ? COLORS.PRIMARY : 'white'};
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  color: ${props => props.variant === 'primary' ? 'white' : COLORS.SECONDARY};

  &:hover:not(:disabled) {
    background: ${props => props.variant === 'primary' ? `${COLORS.PRIMARY}dd` : '#f5f5f5'};
    color: ${props => props.variant === 'primary' ? 'white' : COLORS.PRIMARY};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    font-size: 12px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`; 